purchaseOrderDirectiveModule = angular.module 'App.Directive.PurchaseOrder', []

purchaseOrderDirectiveModule.directive 'purchaseOrder',
	->
		restrict: 'E'
		scope:
			priceRegions: '=?'
			stockLocations: '=?'
			shops: '=?'
			suppliers: '=?'
			purchaseOrder: '=?'
			showAsReport: '=?'
			isLocked: '=?'
			completionFieldsAreLocked: '=?'
		controller: 'PurchaseOrderDirectiveController'
		controllerAs: 'purchaseOrderDirective'
		bindToController: true
		templateUrl: '@directive/purchase-order/purchase-order.view.html'

purchaseOrderDirectiveModule.directive 'purchaseOrderSuggestion',
	->
		restrict: 'E'
		scope:
			filter: '='
			isLocked: '='
			stockLocations: '=?'
			shops: '=?'
			suppliers: '=?'
		controller: 'PurchaseOrderSuggestionController'
		controllerAs: 'purchaseOrderSuggestion'
		bindToController: true
		templateUrl: '@directive/purchase-order/purchase-order.suggestion.view.html'

purchaseOrderDirectiveModule.directive 'purchaseOrderTable',
	->
		restrict: 'E'
		scope:
			priceRegionId: '='
			filter: '='
			stockLocations: '='
			shops: '='
			suppliers: '='
			showAsReport: '='
			completionFieldsAreLocked: '='
			isLocked: '='
			productsList: '=?'
			purchaseOrder: '=?'
		controller: 'PurchaseOrderTableController'
		controllerAs: 'purchaseOrderTable'
		bindToController: true
		templateUrl: '@directive/purchase-order/table/purchase-order.table.view.html'

purchaseOrderDirectiveModule.directive 'purchaseOrderProductSearch',
	->
		restrict: 'E'
		scope:
			priceRegionId: '=?'
			filter: '='
			isLocked: '='
		controller: 'PurchaseOrderProductSearchController'
		controllerAs: 'purchaseOrderProductSearch'
		bindToController: true
		templateUrl: '@directive/purchase-order/purchase-order.product-search.view.html'

purchaseOrderDirectiveModule.directive 'purchaseOrderModal',
	->
		restrict: 'EA'
		scope:
			stockLocations: '=?'
			shops: '=?'
			suppliers: '=?'
			filter: '=?'
			productsList: '=?'
			copyPurchaseOrderId: '=?'
		bindToController: true
		controllerAs: 'purchaseOrderModalButton'
		controller: ($uibModal, $element, PurchaseOrderService, StockLocationRepository, ShopRepository, SuppliersRepository) ->
			@showModal = =>
				$uibModal.open
					templateUrl: '@directive/purchase-order/modals/purchase-order.modal.view.html'
					controller: 'PurchaseOrderModalController'
					controllerAs: 'purchaseOrderModal'
					bindToController: true
					resolve:
						copyPurchaseOrder: =>
							return PurchaseOrderService.getEntityCopy(@copyPurchaseOrderId)
						stockLocations: =>
							return if @stockLocations? then @stockLocations else StockLocationRepository.getEntities()
						shops: =>
							return if @shops? then @shops else ShopRepository.getEntities()
						suppliers: =>
							return if @suppliers? then @suppliers else SuppliersRepository.getEntities()
						filter: => @filter
						productsList: => @productsList

			$element.on 'click', @showModal

			return
